import $ from 'jquery';
import * as api from './api';
import * as tips from './tips';
import { checkReserveStatus } from './reserve';
const SHARE = '1';
const GAME = '2';
const GAMESHARE = '6';
const TOTALCHANCE = 5; // 最多獲得5次抽獎
$('.j-social').on('click', async ({ target }) => {
  if (!target.dataset.type) return;
  let res = await api.commit(target.dataset.type);
  updateChance(res);
});
export const gameCommit = async () => {
  if (!checkReserveStatus()) return;
  let res = await api.commit(GAME);
  updateChance(res);
};
export const gameShare = async () => {
  if (!checkReserveStatus()) return;
  let res = await api.commit(GAMESHARE);
  updateChance(res);
};
export const shareCb = async () => {
  if (!checkReserveStatus()) return;
  let shareAwardRes = await api.commit(SHARE);
  +shareAwardRes.result > 0
    ? tips.alert('shareSuc')
    : tips.alert('shareAwardFail');
  updateChance(shareAwardRes);
};
const updateChance = res => {
  if (+res.code !== 1) {
    return;
  }
  res.data.isFirst &&
    +res.data.getTotal < TOTALCHANCE &&
    setTimeout(() => {
      $('.j-chance-popup').fadeIn(500);
    }, 400);
  $('.j-count').html(res.data.lotteryChance);
};
